import { AgentT } from '@segurodeceso/core/domain/agent';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { deleteCookie, getCookie, setCookie } from '../utils/cookie';

import storage from './encryptedStorage';

interface AgentStoreStateI {
  agent: AgentT;
  isInitialized: boolean;
  assistedSale?: boolean;
  setAgent: (agent: AgentT, assistedSale?: boolean) => void;
  setDefaultAgent: () => void;
}

const initialState = {
  agent: undefined,
  assistedSale: undefined,
  isInitialized: false,
};

const getInitialState = () => {
  const cookie = getCookie('DEC_AIDED_SELLING');

  if (cookie) {
    try {
      const parsed = JSON.parse(decodeURIComponent(cookie));
      return {
        agent: parsed.agent,
        assistedSale: parsed.assistedSale,
        isInitialized: true,
      };
    } catch (error) {
      console.error('Error parsing cookie:', error);
    }
  }
  return initialState;
};

const useAgentStore = create<AgentStoreStateI>()(
  persist(
    (set) => ({
      ...getInitialState(),
      setAgent: (agent: AgentT, assistedSale?: boolean) => {
        setCookie('DEC_AIDED_SELLING', JSON.stringify({ agent, assistedSale }));

        return set((state) => ({
          agent,
          assistedSale: assistedSale ?? state.assistedSale,
          isInitialized: true,
        }));
      },
      setDefaultAgent: () => {
        deleteCookie('DEC_AIDED_SELLING');

        return set(() => ({
          agent: undefined,
          assistedSale: undefined,
          isInitialized: false,
        }));
      },
    }),
    {
      name: 'deceso-agent-storage',
      storage,
    }
  )
);

export default useAgentStore;
